import React, { useState } from 'react';
import { ConfigProvider, Layout, theme as antdThemeAlgo } from 'antd';
import { antdTheme, theme } from './styles/theme';
import Header from './components/Layout/Header';
import Sidebar from './components/Layout/Sidebar';
import HomePage from './pages/HomePage';
import AnalyzePage from './pages/AnalyzePage';
import ComparePage from './pages/ComparePage';
import './App.css';

const { Content } = Layout;

function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const [collapsed, setCollapsed] = useState(false);

  const renderPage = () => {
    switch (currentPage) {
      case 'home':
        return <HomePage onNavigate={setCurrentPage} />;
      case 'analyze':
        return <AnalyzePage />;
      case 'compare':
        return <ComparePage />;
      default:
        return <HomePage onNavigate={setCurrentPage} />;
    }
  };

  return (
    <ConfigProvider theme={{ ...antdTheme, algorithm: antdThemeAlgo.darkAlgorithm }}>
      <Layout style={{ minHeight: '100vh', background: theme.colors.bgPrimary }}>
        <Header />
        <Layout style={{ background: theme.colors.bgPrimary }}>
          <Sidebar
            currentPage={currentPage}
            onNavigate={setCurrentPage}
            collapsed={collapsed}
            onCollapse={setCollapsed}
          />
          <Layout style={{ padding: '24px', background: theme.colors.bgPrimary }}>
            <Content
              style={{
                background: theme.colors.bgCard,
                padding: 24,
                margin: 0,
                minHeight: 280,
                borderRadius: 8
              }}
            >
              {renderPage()}
            </Content>
          </Layout>
        </Layout>
      </Layout>
    </ConfigProvider>
  );
}

export default App;
